var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',[_c('v-row',[_c('v-col',{staticClass:"text-center pt-12",attrs:{"shrink":""}},[_c('p',{staticClass:"title"},[_vm._v("Logging out.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }